/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SAVE_POLL(state, item) {
    state.respData.unshift(item);
  },
  GET_DATA(state, item) {
    const result = item.data.filter(res => res.uid == item.uid);
    state.respData = result;
  },
  DELETE_DATA(state, item) {
    state.respData.splice(item, 1);
  },
  UPDATE_POLL(state, item) {
    const productIndex = state.respData.findIndex((p) => p.key == item.key)
    Object.assign(state.respData[productIndex], item)
  },
  VIEW_POLL(state, item) {
    state.respDataView = item;
  },
  TEST_DATA(state, item) {
    state.respDataView = item;
  }
}
